import { render, staticRenderFns } from "./StructView.vue?vue&type=template&id=1281f761&scoped=true"
import script from "./StructView.vue?vue&type=script&lang=js"
export * from "./StructView.vue?vue&type=script&lang=js"
import style0 from "./StructView.vue?vue&type=style&index=0&id=1281f761&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281f761",
  null
  
)

export default component.exports